/*
 * Copyright 2026 Sony Corporation
 */

import { Box, Typography } from '@mui/material';

export interface CameraPreviewProps {
  canvasRef: (canvas: HTMLCanvasElement | null) => void;
  /** False when nothing is selected, so the panel says so rather than freezing. */
  active: boolean;
  /**
   * Width over height of the recorded frame. The preview's field of view is
   * vertical, so a canvas of any other shape would show the wrong width.
   */
  aspect?: number;
}

/**
 * What the selected camera sees.
 *
 * Titled *Preview*, not *Live*: it is a render of the scene from the camera's
 * point of view with its Creative Look applied, and these cameras have no image
 * sensor in this system at all.
 */
export const CameraPreview = ({ canvasRef, active, aspect = 3 / 2 }: CameraPreviewProps) => (
  <Box className="relative w-full overflow-hidden rounded bg-slate-900" sx={{ aspectRatio: aspect }}>
    <canvas ref={canvasRef} className="block h-full w-full" />
    {!active && (
      <Box className="absolute inset-0 flex items-center justify-center">
        <Typography variant="caption" className="text-slate-400">
          No camera selected
        </Typography>
      </Box>
    )}
  </Box>
);
